import React, {
	createContext,
	useCallback,
	useContext,
	useEffect,
	useMemo,
	useState,
} from "react";
import API from "helpers/api";

const MaintenanceBannerContext = createContext({
	banner: null,
	refresh: () => {},
});

export function MaintenanceBannerProvider({ children }) {
	const [banner, setBanner] = useState(null);

	// The API returns the active banner (VisibleFrom <= now < EndsAt) with a per-user
	// `dismissed` flag, or null. Windowing and dismissal are decided server-side.
	const refresh = useCallback(() => {
		API.get("/api/maintenance-banner")
			.then((res) => {
				const data = res?.data;
				setBanner(data && !data.dismissed ? data : null);
			})
			.catch(() => setBanner(null));
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const value = useMemo(() => ({ banner, refresh }), [banner, refresh]);

	return (
		<MaintenanceBannerContext.Provider value={value}>
			{children}
		</MaintenanceBannerContext.Provider>
	);
}

export const useMaintenanceBanner = () => useContext(MaintenanceBannerContext);
